import React from "react";
import { Box, Container } from "@mui/material";
import GoogleAuthModal from "../authPopup/GoogleAuthModal";
import FondoDinamico from "../components/fondos/BoxBackground";

const Login = () => {
  return (
    <FondoDinamico>
      <Container
        maxWidth="sm"
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4,
        }}
      >
        <GoogleAuthModal isLoginProp={true} />
      </Container>
    </FondoDinamico>
  );
};

export default Login;